        
export class AddressViewModel {
    constructor(u) {
        this.city = u.city,
        this.country_id =u.country_id,
        this.postal_code = u.postal_code,
        this.address_line1=u.address_line1,
        this.address_line2=u.address_line2
    }

}

